import { render } from "./RedFlower.svg?vue&type=template&id=3253ba98"
const script = {}
script.render = render

export default script